import { Input as MantineInput } from '@mantine/core';
import InputStyles from '../styles/Input.module.css';
import { FC } from 'react';

export type MantineInputLabelProps = React.ComponentProps<typeof MantineInput.Label>;

export const InputLabel: FC<MantineInputLabelProps> = props => {
    return (
        <MantineInput.Label
            classNames={{
                label: InputStyles.label,
                required: InputStyles.required,
            }}
            {...props}
        />
    );
};
